module.exports = __webpack_public_path__ + "img/checkAccount.0907a38f.svg";